import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class LogistikProductOrdering extends MongoEntity {
  public static override _class = 'LogistikProductOrdering';
  public static override _collectionName = 'orderings';

  @validate(nonOptional())
  @Field(() => [ID])
  public productIDs!: string[];

  @validate(nonOptional())
  @Field(() => String)
  public productCategory!: string;
}
